module.exports = __webpack_public_path__ + "static/media/pic_3_20.f0ec1e0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pic_3_20.jpg
// module id = 1836
// module chunks = 0 1